<div class="toggle" [ngClass]="{ hide: showLeftPanel() }">
  <button type="button" class="toggle-right" (click)="toggleLeftPanel()">
    <img
      class="warning-icon"
      alt="toggle_right icon"
      src="images/layout_right.png"
    />
  </button>
</div>
<div class="search-panel" [ngClass]="{ hide: !showLeftPanel() }">
  <div class="search-header">
    <div class="search-box">
      <div class="search-text-content">
        <div class="search-text">
          {{ 'GENERAL.SEARCH' | translate }}
        </div>
      </div>
      <button type="button" class="toggle" (click)="toggleLeftPanel()">
        <img
          class="warning-icon"
          src="images/layout_right.png"
          alt="toggle_left icon"
        />
      </button>
    </div>
  </div>
  <div class="search-container" #searchContainerRef cdkScrollable>
    <ng-content select="[searchPanelContent]"></ng-content>
  </div>
</div>
